import { REMINDER_CHANNELS, type TReminder } from '@src/shared/types/reminder';
import {
  REMINDER_TEMPLATE_STATUS,
  type TReminderTemplate,
} from '@src/shared/types/reminder-template';

/** Only WhatsApp templates go through provider approval; these channels never do. */
const ALWAYS_APPROVED_CHANNELS: TReminder['notification_channel'][] = [
  REMINDER_CHANNELS.sms,
  REMINDER_CHANNELS.email,
];

export const isAlwaysApprovedChannel = (
  channel: TReminder['notification_channel']
) => {
  return ALWAYS_APPROVED_CHANNELS.includes(channel);
};

export const getEffectiveTemplateStatus = ({
  channel,
  status,
}: Pick<TReminderTemplate, 'channel' | 'status'>) => {
  return isAlwaysApprovedChannel(channel)
    ? REMINDER_TEMPLATE_STATUS.approved
    : status;
};

export const isTemplateApproved = (
  template: Pick<TReminderTemplate, 'channel' | 'status'>
) => {
  return (
    getEffectiveTemplateStatus(template) === REMINDER_TEMPLATE_STATUS.approved
  );
};

/**
 * Server-side filter for a channel's template list. SMS and Email skip
 * approval, so their lists are not narrowed by stored status.
 */
export const getApprovedTemplatesQuery = (
  channel: TReminder['notification_channel']
) => {
  return isAlwaysApprovedChannel(channel)
    ? {}
    : { status: REMINDER_TEMPLATE_STATUS.approved };
};

/** Reminder template selectors must only offer approved templates. */
export const filterApprovedTemplates = <
  T extends Pick<TReminderTemplate, 'channel' | 'status'>,
>(
  templates: T[]
) => {
  return templates.filter(isTemplateApproved);
};
